import "./index.scss"

require.context("./static", true, /\.jpg|webp$/)
